// Preloading example from https://angular.io/docs/ts/latest/guide/router.html#!#custom-preloading

import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { MxLoggingService } from '../services';

@Injectable()
export class MxPreloadModulesStrategy implements PreloadingStrategy {

  constructor(private log: MxLoggingService) {}

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data['preload']) {
      this.log.log('Preloaded: ' + route.path);
      return load();
    } else {
      return of(null);
    }
  }

}
